<template>
    <div>
      <!-- 导航 -->
      <el-breadcrumb>
        <el-breadcrumb-item>
          <router-link to="./">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>淘汰原因</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 主体内容 -->
      <div class="content">
        <el-form inline label-position="right" label-width="80px" size="small" class="query-form"
          @submit.native.prevent="getList()">
          <el-form-item label="搜索">
            <el-input v-model="query.key" placeholder="请输入关键词" style="width:215px;"></el-input>
          </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="selList()">查询</el-button>
              <el-button type="success" @click="addClick()">新增</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表查询 -->
        <el-card class="box-card table">
          <div slot="header" class="clearfix">
            <span>淘汰原因列表</span>
          </div>
          <!-- 列表定义 -->
          <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%"
            :row-class-name="tableRowClassName">
            <el-table-column prop="name" label="标题"></el-table-column>
            <el-table-column prop="isEnable" label="是否可用">
                <template #default="sc">
                <el-tag v-if="sc.row.isEnable" type="success">是</el-tag>
                <el-tag v-else type="warn">否</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            
            <el-table-column label="操作" fixed="right" width="80">
                <template #default="scope">
                <el-tooltip content="编辑" placement="top">
                    <!-- <el-button type="primary" size="small" plain @click="editClick(scope.row)">
                    <el-icon><edit></edit></el-icon>
                    </el-button> -->
                    <el-tooltip content="编辑" placement="top">
                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                    </el-tooltip>
                </el-tooltip>
                <!-- <el-tooltip content="删除" placement="top">
                    <el-button type="danger" size="small" plain @click="delClick(scope.row)">
                    <el-icon><delete></delete></el-icon>
                    </el-button>
                </el-tooltip> -->
                <el-tooltip content="删除" placement="top">
                  <el-button type="danger" size="mini" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
                </el-tooltip>
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作" :width="200">
              <template slot-scope="scope">
                <el-button-group v-if="userIsMarket">
                  <el-tooltip content="查看详情" placement="top">
                    <el-button type="success" size="mini" icon="el-icon-view"
                      @click="showstuid = scope.row.id"></el-button>
                  </el-tooltip>
                </el-button-group>
                <el-button-group v-else>
                  <el-tooltip content="查看详情" placement="top">
                    <el-button type="success" size="mini" icon="el-icon-view"
                      @click="showstuid = scope.row.id"></el-button>
                  </el-tooltip>
                  <el-tooltip content="评估表" placement="top">
                    <el-button type="warning" size="mini" icon="el-icon-notebook-2"
                      @click="tabClick(scope.row.id)"></el-button>
                  </el-tooltip>
  
                  <el-tooltip content="编辑" placement="top">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip content="跟进详情" placement="top">
                    <a :href="'/vue/follow?id=' + scope.row.id" target="_blank" style="
                        display: inline-block;
                        float: left;
                        margin-right: -1px;
                      ">
                      <el-button type="success" size="mini" icon="el-icon-user" style="
                          border-top-rgiht-radius: 0px;
                          border-bottom-right-radius: 0px;
                        "></el-button>
                    </a>
                  </el-tooltip>
                </el-button-group>
              </template>
            </el-table-column> -->
          </el-table>
  
          <!-- 分页条 -->
          <div class="block" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
              layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </el-card>
      </div>
  
      <!-- 操作对话框 -->
      <el-dialog :title="form.id > 0 ? '编辑淘汰原因' : '添加淘汰原因'" :visible.sync="dialogVisible">
        <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
          @submit.native.prevent="submitForm('form')">
         
          
              <el-form-item label="标题" prop="name" :rules="[{ required: true, message: '请输入标题' }]">
                <el-input v-model="form.name" placeholder="请输入标题"></el-input>
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="是否可用">
                    <el-switch v-model="form.isEnable"></el-switch>
                    </el-form-item>
                </el-col>
              </el-row>
          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
            <el-button @click="dialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import url from "@/plugins/urlHelper.js";
  import user from "@/plugins/user.js";
  import StudentShow from "@/components/StudentShow";
  export default {
    name: 'common',
    data() {
      return {
        domain: url.getDomain(),
        query: {}, //对象
        loading: false,
        currentPage4: 1,
        pageSize: 10,
        total: 0,
        tableData: [],
        form: {}, //表单对象
        dialogVisible: false,
        evalDialogVisible: false,
        submiting: false,
        stuid: 0,
        areaList: [], //地区
        selectedOptions: [],
        adviserList: [],
        documentList: [],
        marketList: [],
        sourselist: [], //来源
        
    
        showstuid: 0,
      
        selectedOrigion: [],
      
     
        sourselist2: [],
        ischildren: false,
        labelorgin: '',
        isMkt: false,
      };
    },
    components: {
      StudentShow,
    },
    methods: {
      //行样式
      tableRowClassName({ row, rowIndex }) {
        if (row.state === "c") {
          return "success-row";
        } else if (row.state === "e") {
          return "info-row";
        }
        return "";
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage4 = 1;
        this.getList();
      },
      handleCurrentChange(val) {
        this.currentPage4 = val;
        this.getList();
      },
      //筛选
      filterTag(filter) {
        var val = filter["isEnable"][0];
        this.form.isEnable = val;
        //刷新列表
        this.getList();
      },
      //排序
      sortChange(sortColumn) {
        this.form.sort = sortColumn.prop;
        this.form.order = sortColumn.order;
        //刷新列表
        this.getList();
      },
     
    // 新增
    addClick() {
      this.dialogVisible = true
      this.form = {
        isEnable: true
      }
    },
      
      getList: function () {
        var _this = this;
        _this.loading = true;
        var params = _this.query;
        params.pageindex = _this.currentPage4;
        params.pagesize = _this.pageSize;
        var link = url.getER("ERGetList");
        $.get(link, params, (data) => {
          _this.loading = false;
          _this.tableData = data.list;
          _this.total = data.total;
        });
      },
      
      //搜索查询
      selList: function () {
        this.currentPage4 = 1;
        this.getList();
      },
  
     
      //提交表单
     // 提交
     submitForm(formName) {
      var _this = this
      var link = url.getER('ERedit')
      var info = this.form
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true
          //提交后台
          $.post(link, info, (res) => {
            _this.submiting = false
            if (res.status) {
              _this.dialogVisible = false
              _this.getList()
              _this.$message({ type: 'success', message: res.msg })
            } else {
              _this.$message({ type: 'error', message: res.msg })
            }
          })
        } else {
          return false
        }
      })
    },
      
      
      // 修改
    editClick(row) {
      this.form = Object.assign({}, row)
      this.dialogVisible = true
    },
    // 删除
    delClick(row) {
      var _this = this
      var link = url.getER('Delete_ER')
      var id = row.id

      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            if (res.status) {
              _this.getList()

              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除!'
          })
        })
    },
     
    
    },
    created() {
   
        this.getList()
    },
    mounted() {
      
    },
  };
  </script>
  